import { Editor } from "@tinymce/tinymce-react";
 
const CustomEditor = (props: {
    content?: string | null;
    value?: string | null;
    onEditorChange: any;
    disabled?: boolean | null;
    placeholder?: string;
}) => {
    return (
        <div>
            <Editor
                disabled={props.disabled ?? false}
                value={props.content ?? props.value ?? ""}
                init={{
                    placeholder: props.placeholder ?? "",
                    resize: false,
                    branding: false,
                    elementpath: false,
                    licenseKey: "gpl",
                    width: "100%",
                    height: "20rem",
                    margin: "0",
                    menubar: false,
                    outputFormat: "text",
                    contextmenu: false,
                    toolbar_mode: "wrap",
                    plugins: [
                    'advlist',
                    'autolink',
                    'lists',
                    'link',
                    'image',
                    'charmap',
                    'preview',
                    'anchor', 
                    'paste'
                    ],
                    toolbar:
                        "undo redo | " +
                        // "bold italic | fontfamily fontsize | forecolor | " +
                        "bold italic underline | forecolor | " +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist | outdent indent | " +
                        "removeformat | link",
                    content_style:
                        "body { font-family:Montserrat; font-size:14px; color: rgba(0, 0, 0, 0.85); }",
                }}
                onEditorChange={(_newValue, editor) => {
                    props.onEditorChange(editor.getContent({ format: "html" }));
                }}
            />
        </div>
    );
};
 
export default CustomEditor;